import React, { ReactNode } from 'react';
import { ArrowForward, ArrowBack, Close } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import {
    OutcomeBuilderCloseButton,
    OutcomeBuilderContent,
    OutcomeBuilderFooter,
    OutcomeBuilderHeader,
    OutcomeBuilderHeaderRight,
    OutcomeBuilderNav,
    OutcomeBuilderNavItem,
    OutcomeBuilderNavItemBullet,
    OutcomeBuilderStepIndicator,
    OutcomeBuilderWrapper,
} from '../styles';
import { useOutcomeBuilderContext } from './state/hooks/OutcomeBuilderContext';
import { OutcomeConfiguration } from './steps/OutcomeConfiguration';
import { OutcomePreview } from './steps/OutcomePreview';
import { OutcomeRisks } from './steps/OutcomeRisks';

interface OutcomeBuilderProps {
    closeModal: () => void;
}

export const OutcomeBuilder = (props: OutcomeBuilderProps) => {
    const { closeModal } = props;

    const { activeStep, handleNext, handleBack, onSubmit, isNew } = useOutcomeBuilderContext();

    let currentStep: ReactNode;
    switch (activeStep) {
        case 0:
            currentStep = <OutcomeConfiguration />;
            break;
        case 1:
            currentStep = <OutcomeRisks />;
            break;
        case 2:
            currentStep = <OutcomePreview />;
            break;
    }

    return (
        <OutcomeBuilderWrapper>
            <OutcomeBuilderHeader>
                <h2>{isNew ? 'Create' : 'Edit'} Analysis</h2>
                <OutcomeBuilderNav>
                    <OutcomeBuilderNavItem $isActive={activeStep === 0} variant="body1">
                        {activeStep === 0 ? (
                            <OutcomeBuilderStepIndicator variant="square">1</OutcomeBuilderStepIndicator>
                        ) : (
                            <OutcomeBuilderNavItemBullet>•</OutcomeBuilderNavItemBullet>
                        )}{' '}
                        Configuration
                    </OutcomeBuilderNavItem>
                    <OutcomeBuilderNavItem $isActive={activeStep === 1} variant="body1">
                        {activeStep === 1 ? (
                            <OutcomeBuilderStepIndicator variant="square">2</OutcomeBuilderStepIndicator>
                        ) : (
                            <OutcomeBuilderNavItemBullet>•</OutcomeBuilderNavItemBullet>
                        )}{' '}
                        Risk Factors
                    </OutcomeBuilderNavItem>
                    <OutcomeBuilderNavItem $isActive={activeStep === 2} variant="body1">
                        {activeStep === 2 ? (
                            <OutcomeBuilderStepIndicator variant="square">3</OutcomeBuilderStepIndicator>
                        ) : (
                            <OutcomeBuilderNavItemBullet>•</OutcomeBuilderNavItemBullet>
                        )}{' '}
                        Preview
                    </OutcomeBuilderNavItem>
                </OutcomeBuilderNav>
                <OutcomeBuilderHeaderRight>
                    <OutcomeBuilderCloseButton onClick={closeModal}>
                        <Close />
                    </OutcomeBuilderCloseButton>
                </OutcomeBuilderHeaderRight>
            </OutcomeBuilderHeader>
            <OutcomeBuilderContent $fullScreen={activeStep === 1}>{currentStep}</OutcomeBuilderContent>
            <OutcomeBuilderFooter container>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={7} alignItems="center">
                    <>
                        {activeStep > 0 ? (
                            <Button variant="tertiary" onClick={handleBack} size="medium" startIcon={<ArrowBack />}>
                                Back
                            </Button>
                        ) : null}
                    </>
                </Grid>
                <Grid item sm={6} md={6} lg={5} display="flex" alignItems="center" justifyContent="flex-end">
                    {activeStep < 2 && (
                        <Button variant="primary" onClick={handleNext} endIcon={<ArrowForward />}>
                            Next
                        </Button>
                    )}
                    {activeStep === 2 && (
                        <Button variant="primary" onClick={onSubmit}>
                            Save
                        </Button>
                    )}
                </Grid>
            </OutcomeBuilderFooter>
        </OutcomeBuilderWrapper>
    );
};
